import { List } from 'antd';
import React from 'react';
import { ReactComponent as Clarity } from '../../assets/svg/clarity_pinned-solid.svg';
var PinnedMessages = function (_a) {
    var data = _a.data, getMessage = _a.getMessage;
    return (React.createElement(List, { itemLayout: "horizontal", className: "pinned-messages-container", dataSource: data, renderItem: function (item) { return (React.createElement(List.Item, { onClick: function () { return getMessage(item.id); } },
            React.createElement(List.Item.Meta, { avatar: React.createElement(Clarity, null), title: item.title, description: item.description }))); } }));
};
export default PinnedMessages;
